import React from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';

const Error = ({ className, children }) => (<div className={classNames(styles.container, className)}>{children}</div>);

export default Error;
